const id = 3319407;

export const VkPixelPush = (eventSlug: string, value?: any) => {
    if (process.env.NODE_ENV === 'production') {
        // @ts-ignore
        const _tmr = window._tmr || (window._tmr = []);
        _tmr.push({ type: 'reachGoal', id, value: value, goal: eventSlug});
    }
}